import { useState } from "react";
import api from "../../services/api";
import {
  MOCK_COHORT_PREVIEWS,
  MOCK_RUN_RESPONSE
} from "../../config/mockResponses";

export default function Runs() {
  const [runs, setRuns] = useState({});
  const [activeRun, setActiveRun] = useState(null);

  const runCohort = async (cohort) => {
    try {
      const res = await api.get(
        `https://aidemo.fusionsystemsinc.com/api/v1/admin/runs/${cohort.segment_id}`,
        {
          headers: {
            accept: "application/json"
          }
        }
      );

      setRuns(prev => ({
        ...prev,
        [cohort.segment_id]: res.data
      }));

    } catch (err) {
      console.warn("Runs API failed, using mock", err);

      setRuns(prev => ({
        ...prev,
        [cohort.segment_id]: MOCK_RUN_RESPONSE
      }));
    }
  };

  return (
    <div className="content">
      <h2>Runs</h2>

      <table className="data-table">
        <thead>
          <tr>
            <th>Cohort Name</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {MOCK_COHORT_PREVIEWS.map(cohort => {
            const run = runs[cohort.segment_id];

            return (
              <tr key={cohort.segment_id}>
                <td>{cohort.cohort_name}</td>
                <td>
                  {!run && (
                    <button onClick={() => runCohort(cohort)}>
                      Run
                    </button>
                  )}

                  {run && run.status === "COMPLETED" && (
                    <button
                      onClick={() => setActiveRun(run)}
                    >
                      View
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* MODAL */}
      {activeRun && (
        <div className="modal-backdrop">
          <div className="modal">
            <h3>Run Details</h3>

            <p><strong>Run ID:</strong> {activeRun.run_id}</p>
            <p><strong>Status:</strong> {activeRun.status}</p>
            <p><strong>Row Count:</strong> {activeRun.row_count}</p>
            <p>
              <strong>Started At:</strong>{" "}
              {new Date(activeRun.started_at).toLocaleString()}
            </p>
            <p>
              <strong>Finished At:</strong>{" "}
              {new Date(activeRun.finished_at).toLocaleString()}
            </p>

            <button onClick={() => setActiveRun(null)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
